import Card from "./Card";
import firebase from "../firebase";
import { useEffect, useState } from "react";

export default function Members() {
  const refMembers = firebase.firestore().collection("members");
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  function getMembers() {
    setLoading(!loading);
    refMembers
      .where("role", "==", "Member")
      .where("active", "==", true)
      .get()
      .then((querySnapshot) => {
        const items = [];
        querySnapshot.forEach((doc) => items.push(doc.data()));
        setMembers(items);
      });
    setLoading(!loading);
  }
  useEffect(() => {
    getMembers();
  }, []);

  let outsideArr = [];
  let insideArr = [];

  for (let j = 0; j < members.length; j += 3) {
    for (let i = j; i < j + 3; i++) {
      if (members[i]) {
        insideArr.push(members[i]);
      }
    }
    outsideArr.push(insideArr);
    insideArr = [];
  }
  return (
    <div
      className="team-members
        flex
        flex-col
        items-center
        justify-evenly
        relative
      "
    >
      <h1
        className="headline
          mt-20
          mb-1
          md:mb-12
          relative
          text-5xl
          dark:text-white
        "
      >
        The Team
      </h1>
      {
        <div>
          {outsideArr.map((element, index) => (
            <div
              key={index}
              className="member-cards
              flex-col
              md:flex
              md:flex-row
              items-center
              justify-between
              my-12
            "
            >
              {element.map((insideElement) => (
                <div key={insideElement.id}>
                  <Card
                    name={insideElement.name}
                    image={insideElement.profileImage}
                    skill={insideElement.description}
                    position={insideElement.role}
                    classStudying={insideElement.department}
                    year={insideElement.year}
                    linkedin={insideElement.linkedin}
                    github={insideElement.github}
                    facebook={insideElement.facebook}
                    instagram={insideElement.instagram}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      }
    </div>
  );
}
